
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whats-new/whats-new-page",
      function () {
        return require("private-next-pages/whats-new/whats-new-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whats-new/whats-new-page"])
      });
    }
  